import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{updatesData.title}</h2>
          <p className="text-sm text-foreground-500">{updatesData.subtitle}</p>
        </div>
        <div className="relative pl-8 border-l-2 border-background-300">
          {updatesData.items.map((item, idx) => (
            <div key={idx} className="relative pb-6 last:pb-0">
              <span className="absolute -left-[29px] w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-100 top-1"></span>
              <span className="text-xs text-foreground-400 mb-1 block">{item.time}</span>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}